import {
  MinusCircleOutlined,
  MinusOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Space,
  Typography,
} from "antd";
import { movement_types } from "..";
import { commaSeparateNumber } from "../../../../utils/functions";

const WarehouseForm = (props) => {
  // Props
  const {
    onWarehouseSelect,
    warehouseList,
    onRackSelect,
    getRackList,
    getBinList,
    selectedRecord,
    onRemoveItemFromList,
    isItemUpdate,
    calculatePackageTotals,
    trackList,
    type,
    onIssuePackage,
    issuingPackageKey,
  } = props;

  // Antd Constants
  const { Option } = Select;
  const isIssueMovement = Boolean(type?.includes?.("issue"));
  const newPackage = () => ({
    is_delete: 0,
    package_id: null,
    package_detail_id: null,
    package_name: "",
    qty: null,
    loose_status: "no",
    is_new_row: true,
  });

  return (
    <Row>
      <Col span={24}>
        <Form.List name="tracks">
          {(fields, { add, remove }) => (
            <>
              {fields?.map((field, index) => {
                if (!trackList?.[index]?.is_delete) {
                  return (
                    <Card
                      key={field.key}
                      size="small"
                      title={`Warehouse ${index + 1}`}
                      extra={
                        !isItemUpdate && fields.length > 1 ? (
                          <Button
                            danger
                            size="small"
                            icon={<MinusCircleOutlined />}
                            onClick={() => remove(field.name)}
                          >
                            Remove Warehouse
                          </Button>
                        ) : null
                      }
                      style={{
                        borderColor: "#d9e2e8",
                        borderRadius: 8,
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
                        marginBottom: 16,
                      }}
                      headStyle={{
                        backgroundColor: "#f5f9fc",
                        borderRadius: "8px 8px 0 0",
                        minHeight: 40,
                      }}
                      bodyStyle={{ padding: "12px 12px 0" }}
                    >
                      <Row gutter={6}>
                      <Col span={0}>
                        <Form.Item label="" name={[index, "id"]} hidden />
                      </Col>
                      <Col span={!isItemUpdate ? 4 : 5}>
                        <Form.Item
                          label="Warehouse"
                          name={[index, "warehouse_id"]}
                          required
                        >
                          <Select
                            placeholder="Please choose the Name"
                            onSelect={(warehouseId) =>
                              onWarehouseSelect(warehouseId, field.key)
                            }
                            size="small"
                          >
                            {warehouseList &&
                              warehouseList?.map((item, index) => {
                                return (
                                  <Option value={item?.id} key={item?.id}>
                                    {item?.name}
                                  </Option>
                                );
                              })}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={!isItemUpdate ? 3 : 4}>
                        <Form.Item
                          label="Rack"
                          name={[index, "rack_id"]}
                          required
                        >
                          <Select
                            placeholder="Please choose the Name"
                            onSelect={(selectedRackId) =>
                              onRackSelect(selectedRackId, field.key)
                            }
                            size="small"
                          >
                            {getRackList(field.key)?.map((item, index) => {
                              return (
                                <Option value={item?.id} key={item?.id}>
                                  {item?.name}
                                </Option>
                              );
                            })}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={!isItemUpdate ? 3 : 4}>
                        <Form.Item
                          label="Cell"
                          name={[index, "bin_id"]}
                          required
                        >
                          <Select
                            placeholder="Please choose the Name"
                            size="small"
                          >
                            {getBinList(field.key)?.map((item, index) => {
                              return (
                                <Option value={item?.id} key={item?.id}>
                                  {item?.name}
                                </Option>
                              );
                            })}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={!isItemUpdate ? 3 : 4}>
                        <Form.Item
                          label="Balance"
                          name={[index, "total_balance"]}
                        >
                          <InputNumber
                            disabled={!isItemUpdate ? true : false}
                            placeholder="Value"
                            style={{ width: "100%" }}
                            formatter={(value) => commaSeparateNumber(value)}
                            size="small"
                          />
                        </Form.Item>
                      </Col>
                      <Col span={!isItemUpdate ? 3 : 4}>
                        <Form.Item
                          label="Balance Roll"
                          name={[index, "total_shipment"]}
                        >
                          <InputNumber
                            disabled={!isItemUpdate ? true : false}
                            placeholder="Value"
                            style={{ width: "100%" }}
                            formatter={(value) => commaSeparateNumber(value)}
                            size="small"
                          />
                        </Form.Item>
                      </Col>
                      {!isItemUpdate && (
                        <>
                          <Col span={!isItemUpdate ? 3 : 4}>
                            <Form.Item
                              label="Roll"
                              name={[index, "shipment_qty"]}
                              required={
                                movement_types?.includes(type) ? false : true
                              }
                            >
                              <InputNumber
                                placeholder="Value"
                                style={{ width: "100%" }}
                                formatter={(value) =>
                                  commaSeparateNumber(value)
                                }
                                precision={2}
                                size="small"
                                disabled
                              />
                            </Form.Item>
                          </Col>
                          <Col span={!isItemUpdate ? 3 : 4}>
                            <Form.Item
                              label={`Qty in ${selectedRecord?.unit_info?.name}`}
                              name={[index, "total_quantity"]}
                              required
                            >
                              <InputNumber
                                placeholder="Value"
                                style={{ width: "100%" }}
                                formatter={(value) =>
                                  commaSeparateNumber(value)
                                }
                                precision={2}
                                size="small"
                                disabled
                              />
                            </Form.Item>
                          </Col>
                        </>
                      )}
                      <Col span={!isItemUpdate ? 2 : 3}>
                        <Form.Item label=" ">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <MinusCircleOutlined
                              onClick={() =>
                                onRemoveItemFromList(field, remove)
                              }
                              hidden={!isItemUpdate}
                            />
                          </div>
                        </Form.Item>
                      </Col>
                      {!isItemUpdate && (
                        <Col span={24}>
                          <div
                            style={{
                              border: "1px solid #d9d9d9",
                              borderRadius: 6,
                              marginBottom: 16,
                              overflow: "hidden",
                            }}
                          >
                            <Row
                              gutter={8}
                              style={{
                                backgroundColor: "#39769d",
                                color: "#fff",
                                padding: "7px 10px",
                              }}
                            >
                              <Col span={2}>
                                <Typography.Text strong style={{ color: "#fff" }}>
                                  Count
                                </Typography.Text>
                              </Col>
                              <Col span={7}>
                                <Typography.Text strong style={{ color: "#fff" }}>
                                  Loose Status
                                </Typography.Text>
                              </Col>
                              <Col span={7}>
                                <Typography.Text strong style={{ color: "#fff" }}>
                                  Roll No
                                </Typography.Text>
                              </Col>
                              <Col span={6}>
                                <Typography.Text strong style={{ color: "#fff" }}>
                                  Qty
                                </Typography.Text>
                              </Col>
                              <Col span={2} style={{ textAlign: "center" }}>
                                <Typography.Text strong style={{ color: "#fff" }}>
                                  Actions
                                </Typography.Text>
                              </Col>
                            </Row>

                            <div style={{ padding: "8px 10px 2px" }}>
                              <Form.List name={[index, "packages"]}>
                                {(
                                  packageFields,
                                  {
                                    add: addPackage,
                                    remove: removePackage,
                                  },
                                ) => (
                                  <>
                                    {packageFields.map(
                                      (packageField, packageIndex) => (
                                      <Row
                                        gutter={8}
                                        key={packageField.key}
                                        align="middle"
                                        style={{ minHeight: 40 }}
                                      >
                                        <Col span={2}>
                                          <Typography.Text>
                                            {packageIndex + 1}
                                          </Typography.Text>
                                          <Form.Item
                                            name={[packageIndex, "is_delete"]}
                                            hidden
                                            initialValue={0}
                                          >
                                            <Input type="hidden" />
                                          </Form.Item>
                                          <Form.Item
                                            name={[packageIndex, "package_id"]}
                                            hidden
                                            initialValue={null}
                                          >
                                            <Input type="hidden" />
                                          </Form.Item>
                                          <Form.Item
                                            name={[
                                              packageIndex,
                                              "package_detail_id",
                                            ]}
                                            hidden
                                            initialValue={null}
                                          >
                                            <Input type="hidden" />
                                          </Form.Item>
                                        </Col>
                                        <Col span={7}>
                                          <Form.Item
                                            noStyle
                                            shouldUpdate={(previous, current) => {
                                              const previousPackage =
                                                previous?.tracks?.[index]
                                                  ?.packages?.[packageIndex];
                                              const currentPackage =
                                                current?.tracks?.[index]
                                                  ?.packages?.[packageIndex];
                                              return (
                                                previousPackage?.loose_status !==
                                                  currentPackage?.loose_status ||
                                                previousPackage?.is_new_row !==
                                                  currentPackage?.is_new_row
                                              );
                                            }}
                                          >
                                            {({ getFieldValue, setFields }) => {
                                              const looseStatus =
                                                getFieldValue([
                                                  "tracks",
                                                  index,
                                                  "packages",
                                                  packageIndex,
                                                  "loose_status",
                                                ]) || "no";
                                              const isNewRow = Boolean(
                                                getFieldValue([
                                                  "tracks",
                                                  index,
                                                  "packages",
                                                  packageIndex,
                                                  "is_new_row",
                                                ]),
                                              );
                                              const setLooseStatus = (value) => {
                                                setFields([
                                                  {
                                                    name: [
                                                      "tracks",
                                                      index,
                                                      "packages",
                                                      packageIndex,
                                                      "loose_status",
                                                    ],
                                                    value,
                                                  },
                                                ]);
                                                calculatePackageTotals();
                                              };

                                              return (
                                                <Space>
                                                  <Checkbox
                                                    checked={
                                                      looseStatus === "yes"
                                                    }
                                                    disabled={isNewRow}
                                                    onChange={() =>
                                                      setLooseStatus("yes")
                                                    }
                                                  >
                                                    Yes
                                                  </Checkbox>
                                                  <Checkbox
                                                    checked={
                                                      looseStatus === "no"
                                                    }
                                                    onChange={() =>
                                                      setLooseStatus("no")
                                                    }
                                                  >
                                                    No
                                                  </Checkbox>
                                                </Space>
                                              );
                                            }}
                                          </Form.Item>
                                          <Form.Item
                                            name={[
                                              packageIndex,
                                              "loose_status",
                                            ]}
                                            initialValue="no"
                                            hidden
                                          />
                                          <Form.Item
                                            name={[packageIndex, "is_new_row"]}
                                            hidden
                                          />
                                        </Col>
                                        <Col span={7}>
                                          <Form.Item
                                            name={[
                                              packageIndex,
                                              "package_name",
                                            ]}
                                            style={{ marginBottom: 6 }}
                                            rules={[
                                              {
                                                required: true,
                                                message:
                                                  "Roll No is required",
                                              },
                                            ]}
                                          >
                                            <Input
                                              placeholder="Roll No"
                                              size="small"
                                              disabled={isIssueMovement}
                                            />
                                          </Form.Item>
                                        </Col>
                                        <Col span={6}>
                                          <Form.Item
                                            noStyle
                                            shouldUpdate={(previous, current) =>
                                              previous?.tracks?.[index]
                                                ?.packages?.[packageIndex]
                                                ?.loose_status !==
                                              current?.tracks?.[index]
                                                ?.packages?.[packageIndex]
                                                ?.loose_status
                                            }
                                          >
                                            {({ getFieldValue }) => {
                                              const looseStatus =
                                                getFieldValue([
                                                  "tracks",
                                                  index,
                                                  "packages",
                                                  packageIndex,
                                                  "loose_status",
                                                ]) || "no";

                                              return (
                                                <Form.Item
                                                  name={[packageIndex, "qty"]}
                                                  style={{ marginBottom: 6 }}
                                                  rules={[
                                                    {
                                                      required: true,
                                                      message:
                                                        "Qty is required",
                                                    },
                                                  ]}
                                                >
                                                  <InputNumber
                                                    min={0}
                                                    precision={2}
                                                    placeholder="Qty"
                                                    size="small"
                                                    style={{ width: "100%" }}
                                                    disabled={
                                                      isIssueMovement &&
                                                      looseStatus === "no"
                                                    }
                                                  />
                                                </Form.Item>
                                              );
                                            }}
                                          </Form.Item>
                                        </Col>
                                        <Col span={2}>
                                          <Space
                                            size={6}
                                            align="center"
                                            style={{
                                              display: "flex",
                                              justifyContent: "center",
                                            }}
                                          >
                                            {isIssueMovement ? (
                                              <Button
                                                type="primary"
                                                size="small"
                                                loading={
                                                  issuingPackageKey ===
                                                  `${index}-${packageIndex}`
                                                }
                                                disabled={Boolean(
                                                  issuingPackageKey,
                                                )}
                                                onClick={() =>
                                                  onIssuePackage?.(
                                                    index,
                                                    packageIndex,
                                                  )
                                                }
                                              >
                                                Issue
                                              </Button>
                                            ) : (
                                              <>
                                                <Button
                                                  type="primary"
                                                  size="small"
                                                  icon={
                                                    <PlusOutlined
                                                      style={{
                                                        color: "#fff",
                                                        display: "inline-flex",
                                                        fontSize: 14,
                                                      }}
                                                    />
                                                  }
                                                  title="Add row"
                                                  style={{
                                                    alignItems: "center",
                                                    display: "inline-flex",
                                                    height: 30,
                                                    justifyContent: "center",
                                                    padding: 0,
                                                    width: 30,
                                                  }}
                                                  onClick={() =>
                                                    addPackage(
                                                      newPackage(),
                                                      packageIndex + 1,
                                                    )
                                                  }
                                                />
                                                <Button
                                                  size="small"
                                                  icon={
                                                    <MinusOutlined
                                                      style={{
                                                        color: "#fff",
                                                        display: "inline-flex",
                                                        fontSize: 14,
                                                      }}
                                                    />
                                                  }
                                                  title="Remove row"
                                                  disabled={
                                                    packageFields.length === 1
                                                  }
                                                  style={{
                                                    alignItems: "center",
                                                    backgroundColor: "#8c8c8c",
                                                    borderColor: "#8c8c8c",
                                                    color: "#fff",
                                                    display: "inline-flex",
                                                    height: 30,
                                                    justifyContent: "center",
                                                    padding: 0,
                                                    width: 30,
                                                  }}
                                                  onClick={() =>
                                                    removePackage(
                                                      packageField.name,
                                                    )
                                                  }
                                                />
                                              </>
                                            )}
                                          </Space>
                                        </Col>
                                      </Row>
                                      ),
                                    )}
                                  </>
                                )}
                              </Form.List>
                            </div>
                          </div>
                        </Col>
                      )}
                      </Row>
                    </Card>
                  );
                } else {
                  return null;
                }
              })}
              <Form.Item>
                {!isItemUpdate && !isIssueMovement && (
                  <Button
                    type="dashed"
                    onClick={() => add({ packages: [newPackage()] })}
                    block
                    icon={<PlusOutlined />}
                    size="small"
                    style={{
                      borderColor: "#39769d",
                      color: "#39769d",
                      height: 36,
                    }}
                  >
                    Add Warehouse
                  </Button>
                )}
              </Form.Item>
            </>
          )}
        </Form.List>
      </Col>
    </Row>
  );
};

export default WarehouseForm;
